// extracted by mini-css-extract-plugin
module.exports = {"Marker":"Marker-module--Marker--3Q2qP"};